import * as yup from 'yup';
import moment from "moment";

interface TestContextExtended {
  [key: string]: any;
}

function editPromotionValidationSchema() {
return yup.object({
      configurationParameters: yup.object({
        country: yup
          .string()
          .required('Market has to be selected'),
        language: yup
          .string()
          .required('Language has to be selected'),
        configurationEndUtc: yup.mixed()
          .test("endDateTest", "End date cannot be before or the same as Start date",
          (value, testContext) => {
            const {from} = testContext as yup.TestContext & TestContextExtended;
            if(moment(from[0].value.configurationStartUtc).isAfter(moment(value), 'minute')) {
              return false;
            }
            return true;
          }),
        ajoEmailTemplate: yup
          .string()
          .max(90, 'The maximum length of the AJO template name is 90 characters'),
          additionalInformation: yup.object({
            name:yup
              .string()
              .max(90,'The maximum length of the promotion name is 90 characters')
              .required('Promotion name cannot be empty'),
            description:yup
              .string()
              .test(
                'max-plain-text-long',
                'The maximum length is 1000 characters',
                (value) => {
                    if (!value) return true;
                    const plainText = value.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ');
                    return plainText.length <= 1000;
                },
            ),
            shortDescription:yup
              .string()
              .test(
                'max-plain-text-short',
                'The maximum length is 250 characters',
                (value) => {
                    if (!value) return true;
                    const plainText = value.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ');
                    return plainText.length <= 250;
                },
            ),
        })
    })
})}

export { editPromotionValidationSchema }
